<script>
import toast from '@/store/toast'

export default {
  name: 'GlobalToast',
  // 方法：绑定全局 toast 响应式状态
  data() {
    return {
      toastState: toast.state
    }
  },
  // 方法：组件销毁时关闭遗留提示
  beforeDestroy() {
    toast.clear()
  }
}
</script>

<template>
  <transition name="global-toast-fade">
    <div v-if="toastState.visible" class="global-toast">{{ toastState.message }}</div>
  </transition>
</template>

<style scoped lang="less">
.global-toast{
  position: fixed;
  left: 50%;
  top: 92px;
  z-index: 10001;
  max-width: 520px;
  min-width: 180px;
  min-height: 38px;
  padding: 10px 18px;
  border-radius: 6px;
  background: rgba(0, 0, 0, .78);
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  box-sizing: border-box;
  transform: translateX(-50%);
  pointer-events: none;
}

.global-toast-fade-enter-active,
.global-toast-fade-leave-active{
  transition: opacity .2s ease, transform .2s ease;
}

.global-toast-fade-enter,
.global-toast-fade-leave-to{
  opacity: 0;
  transform: translateX(-50%) translateY(-4px);
}
</style>
